export enum PlayerSuspensionReasonTypes {
  ActivePaymentDisputes = 1,
  InappropriateBehavior = 2,
  SuspiciousActivity = 3,
  Other = 4
}
